import React from "react"
import * as S from "./styled"

export const ButtonBlock = ({ children }) => {
  return <S.Wrapper>{children}</S.Wrapper>
}
